<template>
  <div>
    <b-form-group label-for="Company" label="Company" v-if="!hideCompany">
      <b-form-select id="Company"
            :options="companyList"
            required
            v-model="adForm.company">
      </b-form-select>              
      <b-form-valid-feedback>
        Valid company provided.
      </b-form-valid-feedback>
      <b-form-invalid-feedback>
        Select company.
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group label-for="Region" label="Region" v-if="!hideRegion">
      <b-form-select id="Region"
            :options="regionList"
            v-model="adForm.region">
      </b-form-select>              
      <b-form-valid-feedback>
        Valid region provided.
      </b-form-valid-feedback>
      <b-form-invalid-feedback>
        Select region.
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group label-for="Branch" label="Branch" v-if="!hideBranch && adForm.region">
      <b-form-select id="Branch"
            :options="branchList"
            v-model="adForm.branch">
      </b-form-select>              
      <b-form-valid-feedback>
        Valid branch provided.
      </b-form-valid-feedback>
      <b-form-invalid-feedback>
        Select branch.
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group label-for="Device" label="Device" v-if="!hideDevice && adForm.branch">
      <b-form-select id="Device"
            :options="deviceList"
            v-model="adForm.device">
      </b-form-select>              
      <b-form-valid-feedback>
        Valid device provided.
      </b-form-valid-feedback>
      <b-form-invalid-feedback>
        Select device.
      </b-form-invalid-feedback>
    </b-form-group>
  </div>
</template>
<script>
import axios from 'axios'

export default {
  name: 'allocation',
  props: ['adForm','hideCompany','hideRegion','hideBranch','hideDevice','isEdit'],
  data () {
    return {
      companies: [],
      regions: [],
      branches: [],
      devices: []
    }
  },
  computed: {
    companyList: function () {
      return this.mapLists(this.companies, false);
    },
    regionList: function () {
      return this.mapLists(this.regions, true);
    },
    branchList: function () {
      return this.mapLists(this.branches, true);
    },
    deviceList: function () {
      return this.mapLists(this.devices, true);
    },
    currentUser () {
      return this.$store.getters.currentUser;
    },
    isSuperAdmin () {
      return this.$store.getters.isSuperAdmin;
    }
  },
  methods: {
    mapLists (list, allowAll) {
      let listItems = list.map((item) => {
        return {
          text: item.name,
          value: item._id
        }
      });
      if(allowAll) {
        listItems.push({text: 'All', value: null})
      }
      return listItems;
    },
    getItems (route) {
      let scope = this;
      return axios.get(process.env.VUE_APP_API + '/' + route, {
      headers: {
        Authorization: 'JWT ' + scope.$localStorage.get('holly-fi-token')
        }
      });
    },
    getCompanies () {
      let scope = this;
      scope.getItems('company').then((response) => {
        scope.companies = response.data;
        if(!scope.isEdit) {
          scope.adForm.company = scope.currentUser.company;
          this.companyChange(scope.currentUser.company);
        }
      });
    },
    getRegions () {
      this.getItems(`region?where={"company":"${this.adForm.company}"}&limit=1000&page=1`).then(response => this.regions = response.data);
    },
    getBranches () {
      if(this.adForm.region !== null) {
        this.getItems(`branch?where={"region":"${this.adForm.region}"}&limit=1000&page=1`).then(response => this.branches = response.data.docs);
      }
    },
    getDevices () {
      if(this.adForm.branch !== null) {
        this.getItems(`device?where={"branch":"${this.adForm.branch}"}&limit=1000&page=1`).then(response => this.devices = response.data);
      }
    },
    companyChange (val2) {
      this.getRegions();
      if(val2 !== undefined) {
        this.adForm.region = null;
        this.adForm.branch = null;
        this.adForm.device = null;
      }
    }
  },
  created () {
    this.getCompanies();
  },
  watch: {
    'adForm.company' (val, val2) {
      this.companyChange(val2);
    },
    'adForm.region' (val, val2) {
      this.getBranches();
      if(val2 !== undefined) {
        this.adForm.branch = null;
        this.adForm.device = null;
      }
    },
    'adForm.branch' (val, val2) {
      this.getDevices();
      if(val2 !== undefined) {
        this.adForm.device = null;
      }
    }
  }
}
</script>
